var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useGlobalContext } from '@honeycomb/data';
import { Dialog, DialogContent, DialogHeader } from '@honeycomb/ui-core';
import React, { useMemo } from 'react';
export function TrustYouReviewDialog(_a) {
    var { clusterId, hotelName } = _a, other = __rest(_a, ["clusterId", "hotelName"]);
    const { configSettings: { TrustYouReviewsAPIKey }, } = useGlobalContext();
    const reviewSrc = useMemo(() => `https://api.trustyou.com/hotels/${encodeURIComponent(clusterId)}/meta_review.html?key=${TrustYouReviewsAPIKey}&custom_style={"primaryColor": "0x69BE28"}`, [clusterId, TrustYouReviewsAPIKey]);
    return (React.createElement(Dialog, Object.assign({ size: "l", fullScreen: "mobile-only" }, other),
        React.createElement(DialogHeader, { withCloseButton: true, title: hotelName }),
        React.createElement(DialogContent, { overflow: "hidden", pos: "relative" },
            React.createElement("iframe", { title: `TrustYou meta review for ${hotelName}`, src: reviewSrc, style: {
                    border: 'none',
                    width: '100%',
                    height: '100%',
                    display: 'block',
                    minHeight: '600px',
                }, allowFullScreen: true }))));
}
